<div
	[class]="
		cn(
			'flex flex-wrap',
			isHorizontal() ? '-ml-2 flex-row' : 'flex-col pt-5'
		)
	"
>
	@for (item of items(); track $index) {
		<div class="flex items-center">
			<svg-icon
				[attr.data-test-icon-name]="item.iconName"
				[class]="cn('icon-container ' + iconColor())"
				[src]="'assets/icons/' + item.iconName + '.svg'"
				[style]="{
					'--vp-icon-container-icon-color': iconColor(),
				}"
				[svgAriaLabel]="item.title"
			/>
			{{ item.title | translate }}
		</div>
	}
</div>
